import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Html from './html';
import shared from './shared';
import methodModel from '../../methods/methods';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';

function Venues() {
  const searchState = { data: '' };
  const [filters, setFilter] = useState({ page: 1, count: 10, search: '', status: methodModel.getPrams('status') || '' });
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loaging, setLoader] = useState(false);
  const history = useNavigate();

  useEffect(() => {
    setFilter((prev) => ({ ...prev, search: searchState.data }));
    getData({ search: searchState.data, page: 1 });
  }, []);

  const getData = async (params = {}) => {
    loader(true)
    const payload = {
      ...filters,
      ...params
    };
    ApiClient.get(shared.listApi, payload).then(response => {
      loader(false);
      if (response?.success) {
        setData(response?.data || []);
        setTotal(response?.total || 0);
      } else {
        setData([]);
        setTotal(0);
      }
    })

  };

  const sortClass = (key) => {
    let cls = 'fa-sort';
    if (filters.key === key && filters.sorder === 'asc') cls = 'fa-sort-up';
    else if (filters.key === key && filters.sorder === 'desc') cls = 'fa-sort-down';
    return `fa ${cls}`;
  };

  const sorting = (key) => {
    let sorder = 'asc';
    if (filters.key === key && filters.sorder === 'asc') sorder = 'desc';

    const updatedFilters = {
      ...filters,
      sortBy: `${key} ${sorder}`,
      key,
      sorder,
    };

    setFilter(updatedFilters);
    getData(updatedFilters);
  };

  const clear = () => {
    const f = {
      search: '',
      status: '',
      page: 1,
      role: '',
    };
    const updated = { ...filters, ...f };
    setFilter({ ...updated });
    getData({ ...updated });
  };

  const filter = (p = {}) => {
    const updated = { ...filters, page: 1, ...p };
    setFilter(updated);
    getData(updated);
  };

  const deleteItem = async (id) => {
    methodModel.DeleteData(shared.deleteApi, id, shared.addTitle, clear)
  };

  const pageChange = (e) => {
    const updated = { ...filters, page: e };
    setFilter(updated);
    getData(updated);
  };

  const count = (e) => {
    const updated = { ...filters, count: e, page: 1 };
    setFilter(updated);
    getData(updated);
  };

  const changestatus = (status) => {
    const updated = { ...filters, status, page: 1 };
    setFilter(updated);
    getData(updated);
  };

  const statusChange = async (itm) => {
    methodModel.StatusChange(shared.statusApi, itm, shared.title, getData)
  };

  const edit = (id) => {
    history(`/${shared.url}/edit/${id}`);
  };

  const view = (id) => {
    history(`/${shared.url}/detail/${id}`);
  };

  const approvalChange = (id, status, reason = null) => {
    let payload = {
      "id": id,
      "approvalStatus": status,
    }
    if (reason) {
      payload['reason'] = reason
    }
    loader(true)
    ApiClient.put(shared.approvalApi, payload).then(res => {
      if (res.success) {
        getData()
      } else {
        loader(false);
      }
    })
  }
  return (
    <Html
      edit={edit}
      view={view}
      clear={clear}
      sortClass={sortClass}
      sorting={sorting}
      count={count}
      pageChange={pageChange}
      deleteItem={deleteItem}
      filters={filters}
      setFilter={setFilter}
      filter={filter}
      loaging={loaging}
      data={data}
      total={total}
      approvalChange={approvalChange}
      statusChange={statusChange}
      changestatus={changestatus}
    />
  );
}

export default Venues;
